import { getRuntimeConfig } from './runtimeConfig'

// Valores que cambian entre ambientes (QA/UAT/PROD) o instancias (EC/PE)
// se leen en RUNTIME desde el singleton hidratado por ConfigRuntimeProvider
// (vía el endpoint /api/config).
//
// Los secretos server-only NO viven aquí; se leen directamente con `process.env` en
// los route handlers.
export const env = {
  // --- Runtime (varían por ambiente/país) ---
  get IS_PRODUCTION(): boolean {
    return getRuntimeConfig().IS_PRODUCTION
  },
  get BASE_URL(): string {
    return getRuntimeConfig().BASE_URL
  },
  get REGION(): string {
    return getRuntimeConfig().REGION
  },
  get CURRENCY(): string {
    return getRuntimeConfig().CURRENCY
  },
  get NEXT_PUBLIC_APP_URL_FRONTEND(): string {
    return getRuntimeConfig().FRONTEND_URL
  },

  // CLIENT_ID y API_SCOPE ahora son RUNTIME (vía /api/config) para que el build sea
  // agnóstico al ambiente y se pueda hacer cascade (un solo artifact QA→UAT→Prod).
  // OJO: cualquier consumo de estos valores debe ocurrir DESPUÉS de que
  // ConfigRuntimeProvider hidrató el config (en cliente). MSAL se crea de forma diferida.
  get CLIENT_ID(): string {
    return getRuntimeConfig().CLIENT_ID
  },
  get API_SCOPE(): string {
    return getRuntimeConfig().API_SCOPE
  },
}
